import { render, staticRenderFns } from "./OrderConnection.vue?vue&type=template&id=0eb5e22a&scoped=true"
import script from "./OrderConnection.vue?vue&type=script&lang=js"
export * from "./OrderConnection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb5e22a",
  null
  
)

export default component.exports